/** Types of logs for project */
enum LogTypes {
  error = "error",
  success = "success"
}

export default LogTypes;
